<template>
  <div>
    <WorkpacksStats />
    <Workpacks
      title="Work Pack Manager"
      :headers="workpacks.headers"
      :filter-keys="filterKeys"
      :data="data"
      :toolbar-buttons="toolbarButtons(['batchDelete'], selectedRows.length === 0)"
      @onToolbarButtonClicked="handleToolbarButtonClicked"
      @onSelectedRowsChanged="handleSelectedRowsChanged"
      @onActionRequested="handleActionRequested"
    />
    <v-dialog v-model="showCreation" max-width="500px" :retain-focus="false">
      <WorkpackCreator
        @onCreateWorkpackAttempt="handleCreateWorkpackAttempt"
        @onCreateWorkpackSuccess="handleCreateWorkpackSuccess"
        @onCreateWorkpackFailure="handleCreateWorkpackFailure"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { WorkpackLevel } from '@/utils';
import { WorkpackCreator, WorkpacksStats } from './components';
import Workpacks from './Workpacks.vue';

export default {
  name: 'WorkpacksContainer',
  components: {
    Workpacks,
    WorkpackCreator,
    WorkpacksStats,
  },
  props: {
    selectedRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showCreation: false,
    };
  },
  computed: {
    ...mapGetters({
      workpacks: 'config/workpacks',
      data: 'workpacks/data',
      toolbarButtons: 'workpacks/currentLevelToolbarButtonsWithDisabledState',
      currentLevelDisplayName: 'workpacks/currentLevelDisplayName',
      workpacksTypes: 'config/workpacksTypes',
    }),
    filterKeys() {
      return this.workpacks.headers.filter(({ filterKey }) => filterKey);
    },
  },
  created() {
    this.initialise();
  },
  methods: {
    ...mapActions({
      initialise: 'workpacks/initialise',
      deleteWorkpack: 'workpacks/delete',
      createWorkpack: 'workpacks/createWorkpack',
      exportWorkpack: 'workpacks/exportWorkpack',
    }),
    handleToolbarButtonClicked(item) {
      switch (item) {
        case 'createBtn':
          this.handleCreateWorkpack();
          break;
        case 'batchDelete':
          this.handleBatchDelete();
          break;
        default:
          break;
      }
    },
    handleCreateWorkpack() {
      this.showCreation = true;
    },
    handleCreateWorkpackAttempt() {
      this.showCreation = false;
    },
    handleCreateWorkpackSuccess(resetFormFunction) {
      resetFormFunction();
    },
    handleCreateWorkpackFailure() {
      this.showCreation = true;
    },
    handleSelectedRowsChanged(rows) {
      this.$emit('onSelectedRowsChanged', rows);
    },
    handleActionRequested({ column, row }) {
      switch (column) {
        case 'Delete':
          this.handleDelete(row);
          break;
        case 'Export':
          this.handleExport(row);
          break;
        default:
          this.handleNextStage(row);
          break;
      }
    },
    handleNextStage(item) {
      this.$router.push({
        name: WorkpackLevel.ITEMS,
        query: {
          id: this.$route.query.id,
          wpType: item.type,
        },
        params: { wpId: item.id },
      });
    },
    handleDelete(row) {
      this.$emit('onDeleteRequested', `You are about to delete ${this.currentLevelDisplayName} ${row.name}`, () =>
        this.deleteWorkpack(row.id)
      );
    },
    handleBatchDelete() {
      this.$emit(
        'onBatchDelete',
        `You are about to delete ${this.selectedRows.length}
          ${this.currentLevelDisplayName}${this.selectedRows.length > 1 ? 's' : ''}`,
        ({ id }) => this.deleteWorkpack(id)
      );
    },
    handleExport(row) {
      this.$emit('onExportRequested', `Export ${row.name} as CSV?`, () =>
        this.exportWorkpack({ id: row.id, inspectionId: this.$route.query.id })
      );
    },
  },
};
</script>
